import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e6838a9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "app" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = {
  key: 0,
  class: "is-flex is-justify-content-space-between is-align-items-start mb-1"
}
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "is-flex is-justify-content-space-between is-align-items-start" }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "gdpr is-unselectable legal" }
const _hoisted_10 = {
  class: "has-text-link",
  href: "https://documoto.com/privacy/",
  target: "_blank"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lg fa-window-close" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_required_reading_modal = _resolveComponent("required-reading-modal")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_notifications, null, {
      body: _withCtx((props) => [
        _createElementVNode("div", {
          class: _normalizeClass(["vue-notification", props.item.type]),
          style: {"padding-right":"1.25rem"},
          onClick: props.close
        }, [
          (props.item.title)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: "notification-title",
                  innerHTML: props.item.title
                }, null, 8, _hoisted_4),
                _createElementVNode("button", {
                  class: "delete",
                  "aria-label": "close",
                  onClick: props.close
                }, null, 8, _hoisted_5)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "notification-content",
              innerHTML: props.item.text
            }, null, 8, _hoisted_7),
            (!props.item.title)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "delete",
                  "aria-label": "close",
                  onClick: props.close
                }, null, 8, _hoisted_8))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_2)
      ]),
      _: 1
    }),
    _createVNode(_component_notifications, {
      group: "cookie",
      position: "bottom center",
      width: "50%"
    }, {
      body: _withCtx((props) => [
        _createElementVNode("p", _hoisted_9, [
          _createVNode(_component_i18n_t, {
            keypath: "gdprMessage",
            tag: "span"
          }, {
            policy: _withCtx(() => [
              _createElementVNode("a", _hoisted_10, _toDisplayString(_ctx.$t('privacyPolicy')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("a", {
          class: "gdpr-close",
          onClick: ($event: any) => (_ctx.handleCookieClose(props))
        }, _hoisted_13, 8, _hoisted_11)
      ]),
      _: 1
    }),
    (_ctx.requiredReadingOpen)
      ? (_openBlock(), _createBlock(_component_required_reading_modal, {
          key: 0,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.requiredReadingOpen = false))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, { id: "router-view" })
  ]))
}